module.exports = __webpack_public_path__ + "img/referrals.ca6b2938.jpg";